import PropTypes from 'prop-types';

const TONES = {
	primary: 'bg-primary-500 text-white hover:bg-primary-600',
	neutral: 'bg-gray-500 text-white hover:bg-gray-600',
};

export default function FloatingActionButton({ children, tone = 'primary', pressed = false, className, ...props }) {
	return (
		<button
			type="button"
			className={`inline-flex h-16 w-16 items-center justify-center rounded-full shadow-lg transition-all duration-200 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-primary-300 ${
				TONES[tone]
			} ${pressed ? 'scale-95' : 'scale-100 hover:scale-105'} ${className || ''}`.trim()}
			{...props}
		>
			{children}
		</button>
	);
}

FloatingActionButton.propTypes = {
	children: PropTypes.node.isRequired,
	tone: PropTypes.oneOf(['primary', 'neutral']),
	pressed: PropTypes.bool,
	className: PropTypes.string,
	onClick: PropTypes.func,
	title: PropTypes.string,
};
